import React from 'react';
import Navbar from './modules/Navbar';
import Hero from './modules/Hero';
import About from './modules/About';
import Guest from './modules/Guest';
import Prizes from './modules/Prizes';
import JudgingCriteria from './modules/JudgingCriteria';
import Timeline from './modules/Timeline';
// import Training from './modules/Training';
// import Gallery from './modules/Gallery';
// import Video from './modules/Video';
// import Register from './modules/Register';
import Partners from "@/modules/Partners";
import PartnerShip from './modules/PartnerShip';
import Faq from './modules/Faq';
import Contact from './modules/Contact';
import Footer from './modules/Footer';
import ScrollButton from './modules/ScrollButton';
import MessageEN from "./message/en_sg";
import Theme from './modules/Theme';
import Application from "@/modules/Application";
import Translator from '@/modules/translator';
import { $t } from '@/modules/i18n';

import './scss/App.scss';

class App extends React.Component {
  constructor(props) {
    super(props);
    this.url = "https://careers.shopee.sg/ultrahackathon";
    this.imageURL = `https://careers.${process.env.REACT_APP_ENV && process.env.REACT_APP_ENV !== 'live' ? process.env.REACT_APP_ENV + '.' : ''}shopee.sg/ultrahackathon/images/ultra.jpg`;
    this.state = {
      message: MessageEN()
    }
  }

  getHelmetScript() {
    const message = this.state.message.application;

    return [{
      type: "application/ld+json",
      innerHTML: JSON.stringify({
        "@context": "http://schema.org",
        "@type": "Event",
        name: $t(message.title),
        description: $t(message.desc),
        image: this.imageURL,
        startDate: $t(message.startDate),
        endDate: $t(message.endDate),
        url: this.url,
        Performer: $t(message.performer),
        audience: {
          "@type": $t(message.audienceType),
          "educationalRole": $t(message.educationalRole)
        },
        location: {
          "@type": "Place",
          name: $t(message.locationName),
          address: $t(message.locationAddress)
        }
      })
    }]
  }

  render() {
    var { message } = this.state;
    const script = this.getHelmetScript();

    return (
      <div className="App">
        {/* <Modal Message={Message} /> */}
        <Application
          message={message.application} 
          url={this.url} 
          imageURL={this.imageURL} 
          script={script}
          meta={[{ 
            name: "author", content: "Shopee Singapore"
          },{
            name: 'og:site_name', content: message.application.title
          }]}
          viewport={false}
        />
        <Navbar Message={message} />
        <ScrollButton scrollStepInPx="50" delayInMs="1.66" />
        <Hero Message={message} />
        <About Message={message} />
        <Guest Message={message} />
        <Timeline Message={message} />
        <Prizes Message={message} />
        <Theme Message={message.theme} />
        <JudgingCriteria Message={message} />

        {/* <Training Message={Message} />
        <Register Message={Message} />
        <Gallery Message={Message}/>
        <Video Message={Message}/> */}

       <Faq Message={message} />
        <Partners message={message.partners} />
        <PartnerShip message={message.partnerShip} />
        <Contact Message={message} />
        <Footer Message={message} />
        
        {/* <h2>{this.state.lang}</h2> */}
      </div>
    );
  }
}

export default Translator(App, MessageEN);
